(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class MessageRotator extends HTMLElement {
    /** @type {AbortController | null} */
    #abortController = null;

    /** @type {HTMLElement[]} */
    #messages = [];

    /** @type {number} */
    #currentIndex = 0;

    /** @type {ReturnType<typeof setInterval> | null} */
    #intervalId = null;

    /** @type {number} */
    #speed = 5000;

    connectedCallback() {
      this.#abortController = new AbortController();
      const { signal } = this.#abortController;

      this.#messages = Array.from(this.querySelectorAll('.message-rotator__item')).filter(
        (item) => item instanceof HTMLElement
      );
      this.#currentIndex = this.#messages.findIndex((item) =>
        item.classList.contains('message-rotator__item--active')
      );

      if (this.#currentIndex < 0) {
        this.#currentIndex = 0;
      }

      this.#speed = Number.parseInt(this.dataset.speed || '', 10) || 5000;
      this.#syncSlideState();

      const autoplay = this.dataset.autoplay === 'true';

      if (this.#messages.length <= 1 || !autoplay) {
        return;
      }

      this.#startRotation();

      this.addEventListener('mouseenter', () => this.#pauseRotation(), { signal });
      this.addEventListener('mouseleave', () => this.#startRotation(), { signal });
    }

    disconnectedCallback() {
      this.#pauseRotation();
      this.#abortController?.abort();
      this.#abortController = null;
    }

    #syncSlideState() {
      for (const [index, message] of this.#messages.entries()) {
        const isActive = index === this.#currentIndex;

        message.classList.toggle('message-rotator__item--active', isActive);
        message.inert = !isActive;
        message.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      }
    }

    #startRotation() {
      this.#pauseRotation();

      this.#intervalId = setInterval(() => {
        this.#rotateToNext();
      }, this.#speed);
    }

    #pauseRotation() {
      if (this.#intervalId !== null) {
        clearInterval(this.#intervalId);
        this.#intervalId = null;
      }
    }

    #rotateToNext() {
      if (this.#messages.length === 0) {
        return;
      }

      this.#currentIndex = (this.#currentIndex + 1) % this.#messages.length;
      this.#syncSlideState();
    }
  }

  if (!customElements.get('message-rotator')) {
    customElements.define('message-rotator', MessageRotator);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-slide-carousel"] && !Shopify.designMode) return;
  try {
    
  class FeatureSlideCarousel extends HTMLElement {
    /** @type {AbortController | null} */
    #abortController = null;

    connectedCallback() {
      this.#abortController = new AbortController();
      const { signal } = this.#abortController;

      const sectionId = this.dataset.sectionId;
      if (!sectionId) return;

      const container = this.querySelector(`#carousel-container-${sectionId}`);
      const track = this.querySelector(`#carousel-track-${sectionId}`);
      const prevBtn = this.querySelector(`#carousel-prev-${sectionId}`);
      const nextBtn = this.querySelector(`#carousel-next-${sectionId}`);

      if (container instanceof HTMLElement) {
        this.#initDragScroll(container, signal);
      }

      if (
        container instanceof HTMLElement &&
        track instanceof HTMLElement &&
        prevBtn instanceof HTMLButtonElement &&
        nextBtn instanceof HTMLButtonElement
      ) {
        this.#initNavigation(container, track, prevBtn, nextBtn, signal);
      }

      this.#initOverlays(signal);
      this.#initOutsideClose(signal);

      document.addEventListener('keydown', (event) => this.#onKeydown(event), { signal });
    }

    disconnectedCallback() {
      this.#abortController?.abort();
      this.#abortController = null;
    }

    /**
     * @param {KeyboardEvent} event
     */
    #onKeydown(event) {
      if (event.key !== 'Escape') return;

      const openPanel = this.querySelector('[data-expand-panel].is-active');
      if (!(openPanel instanceof HTMLElement)) return;

      this.#closePanel(openPanel);
    }

    /**
     * @param {HTMLElement} container
     * @param {AbortSignal} signal
     */
    #initDragScroll(container, signal) {
      let isDown = false;
      let startX = 0;
      let scrollLeft = 0;

      container.addEventListener(
        'mousedown',
        (event) => {
          if (!(event instanceof MouseEvent)) return;
          isDown = true;
          startX = event.pageX - container.offsetLeft;
          scrollLeft = container.scrollLeft;
        },
        { signal }
      );

      container.addEventListener(
        'mouseleave',
        () => {
          isDown = false;
        },
        { signal }
      );

      container.addEventListener(
        'mouseup',
        () => {
          isDown = false;
        },
        { signal }
      );

      container.addEventListener(
        'mousemove',
        (event) => {
          if (!isDown || !(event instanceof MouseEvent)) return;
          event.preventDefault();
          const x = event.pageX - container.offsetLeft;
          const walk = (x - startX) * 2;
          container.scrollLeft = scrollLeft - walk;
        },
        { signal }
      );
    }

    /**
     * @param {HTMLElement} container
     * @param {HTMLElement} track
     * @param {HTMLButtonElement} prevBtn
     * @param {HTMLButtonElement} nextBtn
     * @param {AbortSignal} signal
     */
    #initNavigation(container, track, prevBtn, nextBtn, signal) {
      const slides = track.querySelectorAll('.feature-slide-carousel__slide');
      const slideGap = Number.parseInt(getComputedStyle(track).gap, 10) || 0;

      const getSlideWidth = () => {
        const firstSlide = slides[0];
        if (!(firstSlide instanceof HTMLElement)) return 0;
        return firstSlide.offsetWidth + slideGap;
      };

      const updateButtonStates = () => {
        const maxScroll = container.scrollWidth - container.clientWidth;
        prevBtn.disabled = container.scrollLeft <= 10;
        nextBtn.disabled = container.scrollLeft >= maxScroll - 10;
      };

      const scrollToSlide = (direction) => {
        const slideWidth = getSlideWidth();
        const targetScroll =
          direction === 'next'
            ? container.scrollLeft + slideWidth
            : container.scrollLeft - slideWidth;
        const maxScroll = container.scrollWidth - container.clientWidth;

        container.scrollTo({
          left: Math.max(0, Math.min(targetScroll, maxScroll)),
          behavior: 'smooth',
        });
      };

      prevBtn.addEventListener('click', () => scrollToSlide('prev'), { signal });
      nextBtn.addEventListener('click', () => scrollToSlide('next'), { signal });
      container.addEventListener('scroll', updateButtonStates, { signal });
      window.addEventListener('resize', updateButtonStates, { signal });
      updateButtonStates();
    }

    /**
     * @param {AbortSignal} signal
     */
    #initOverlays(signal) {
      const triggers = this.querySelectorAll('[data-expand-trigger]');

      for (const trigger of triggers) {
        if (!(trigger instanceof HTMLButtonElement)) continue;

        const panelId = trigger.getAttribute('aria-controls');
        const panel = panelId ? this.querySelector(`#${panelId}`) : null;
        if (!(panel instanceof HTMLElement)) continue;

        trigger.addEventListener(
          'click',
          () => {
            const isOpen = panel.classList.contains('is-active');
            this.#closeAllPanels();

            if (!isOpen) {
              this.#openPanel(trigger, panel);
            }
          },
          { signal }
        );

        panel.addEventListener(
          'click',
          (event) => {
            const content = panel.querySelector('.feature-slide-carousel__overlay-content');
            if (content instanceof HTMLElement && content.contains(event.target)) return;
            this.#closePanel(panel);
          },
          { signal }
        );
      }
    }

    /**
     * @param {AbortSignal} signal
     */
    #initOutsideClose(signal) {
      document.addEventListener(
        'click',
        (event) => {
          const openPanel = this.querySelector('[data-expand-panel].is-active');
          if (!(openPanel instanceof HTMLElement)) return;
          if (!(event.target instanceof Node)) return;

          const content = openPanel.querySelector('.feature-slide-carousel__overlay-content');
          if (content instanceof HTMLElement && content.contains(event.target)) return;

          const trigger = this.querySelector(`[aria-controls="${openPanel.id}"]`);
          if (trigger instanceof HTMLElement && trigger.contains(event.target)) return;

          if (openPanel.contains(event.target)) return;

          this.#closePanel(openPanel);
        },
        { signal }
      );
    }

    #closeAllPanels() {
      const panels = this.querySelectorAll('[data-expand-panel]');
      for (const panel of panels) {
        if (panel instanceof HTMLElement) {
          this.#closePanel(panel, { restoreFocus: false });
        }
      }
    }

    /**
     * @param {HTMLButtonElement} trigger
     * @param {HTMLElement} panel
     */
    #openPanel(trigger, panel) {
      panel.classList.add('is-active');
      panel.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
    }

    /**
     * @param {HTMLElement} panel
     * @param {{ restoreFocus?: boolean }} [options]
     */
    #closePanel(panel, { restoreFocus = true } = {}) {
      const wasOpen = panel.classList.contains('is-active');
      panel.classList.remove('is-active');
      panel.setAttribute('aria-hidden', 'true');
      const panelId = panel.id;
      const trigger = this.querySelector(`[aria-controls="${panelId}"]`);
      if (trigger instanceof HTMLButtonElement) {
        trigger.setAttribute('aria-expanded', 'false');
        if (restoreFocus && wasOpen) {
          trigger.focus();
        }
      }
    }
  }

  if (!customElements.get('feature-slide-carousel')) {
    customElements.define('feature-slide-carousel', FeatureSlideCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-slides"] && !Shopify.designMode) return;
  try {
    
  class FeatureSlides extends HTMLElement {
    /** @type {number} */
    #activeIndex = 0;

    /** @type {number} */
    #transitionToken = 0;

    /** @type {ReturnType<typeof setTimeout> | null} */
    #transitionTimer = null;

    /** @type {boolean} */
    #isDown = false;

    /** @type {number} */
    #startX = 0;

    /** @type {number} */
    #scrollLeft = 0;

    /** @type {AbortController | null} */
    #abortController = null;

    connectedCallback() {
      this.#abortController = new AbortController();
      const { signal } = this.#abortController;

      this.addEventListener('click', this.#onClick, { signal });
      this.addEventListener('keydown', this.#onKeydown, { signal });
      this.#setupMobileCarousel(signal);
    }

    disconnectedCallback() {
      this.#clearTransitionTimer();
      this.#abortController?.abort();
      this.#abortController = null;
    }

    #clearTransitionTimer() {
      if (this.#transitionTimer !== null) {
        clearTimeout(this.#transitionTimer);
        this.#transitionTimer = null;
      }
    }

    /**
     * @param {MouseEvent} event
     */
    #onClick = (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      if (target.closest('a, button, input, textarea, select, label')) return;

      const trigger = target.closest('.feature-slides__tab, .feature-slides__mobile-card');
      if (!(trigger instanceof HTMLElement) || !this.contains(trigger)) return;

      const slideIndex = Number(trigger.dataset.slide);
      if (Number.isNaN(slideIndex)) return;

      trigger.focus();
      this.#switchSlide(slideIndex);
    };

    /**
     * @param {KeyboardEvent} event
     */
    #onKeydown = (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const tab = target.closest('[role="tab"]');
      if (!(tab instanceof HTMLElement) || !this.contains(tab)) return;

      const tablist = tab.closest('[role="tablist"]');
      if (!(tablist instanceof HTMLElement) || !this.contains(tablist)) return;

      const tabs = Array.from(tablist.querySelectorAll('[role="tab"]'));
      const currentIndex = tabs.indexOf(tab);
      if (currentIndex < 0) return;

      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        const slideIndex = Number(tab.dataset.slide);
        if (!Number.isNaN(slideIndex)) {
          this.#switchSlide(slideIndex);
        }
        return;
      }

      let nextIndex = currentIndex;

      switch (event.key) {
        case 'ArrowRight':
        case 'ArrowDown':
          nextIndex = (currentIndex + 1) % tabs.length;
          break;
        case 'ArrowLeft':
        case 'ArrowUp':
          nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
          break;
        case 'Home':
          nextIndex = 0;
          break;
        case 'End':
          nextIndex = tabs.length - 1;
          break;
        default:
          return;
      }

      event.preventDefault();
      const nextTab = tabs[nextIndex];
      if (!(nextTab instanceof HTMLElement)) return;

      nextTab.focus();
      const slideIndex = Number(nextTab.dataset.slide);
      if (!Number.isNaN(slideIndex)) {
        this.#switchSlide(slideIndex);
      }
    };

    /**
     * @param {number} slideIndex
     */
    #switchSlide(slideIndex) {
      const panels = this.querySelectorAll('.feature-slides__panel');
      const desktopTabs = this.querySelectorAll('.feature-slides__tab');
      const mobileCards = this.querySelectorAll('.feature-slides__mobile-card');
      const nextPanel = panels[slideIndex];

      if (!(nextPanel instanceof HTMLElement)) return;
      if (this.#activeIndex === slideIndex && nextPanel.style.opacity === '1') return;

      const transitionType = this.dataset.transitionType || 'fade';
      const transitionDuration = Number(this.dataset.transitionDuration) || 400;
      const currentActiveIndex = this.#activeIndex;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const token = ++this.#transitionToken;

      this.#clearTransitionTimer();
      this.#setActiveControls(desktopTabs, slideIndex);
      this.#setActiveControls(mobileCards, slideIndex);
      this.#activeIndex = slideIndex;

      for (const [index, panel] of panels.entries()) {
        if (!(panel instanceof HTMLElement)) continue;
        panel.setAttribute('aria-hidden', index === slideIndex ? 'false' : 'true');
      }

      if (reduceMotion || transitionType !== 'slide') {
        for (const [index, panel] of panels.entries()) {
          if (!(panel instanceof HTMLElement)) continue;
          panel.style.transform = 'translateX(0)';
          panel.style.zIndex = '';
          panel.style.transition = reduceMotion
            ? 'none'
            : `opacity ${transitionDuration}ms ease-in-out`;
          panel.style.opacity = index === slideIndex ? '1' : '0';
        }
        return;
      }

      const currentPanel = panels[currentActiveIndex];
      if (!(currentPanel instanceof HTMLElement) || currentActiveIndex === slideIndex) {
        for (const [index, panel] of panels.entries()) {
          if (!(panel instanceof HTMLElement)) continue;
          panel.style.transition = 'none';
          panel.style.transform = 'translateX(0)';
          panel.style.zIndex = '';
          panel.style.opacity = index === slideIndex ? '1' : '0';
        }
        return;
      }

      for (const [index, panel] of panels.entries()) {
        if (!(panel instanceof HTMLElement)) continue;
        panel.style.transition = 'none';
        panel.style.zIndex = '';
        if (index === currentActiveIndex) {
          panel.style.opacity = '1';
          panel.style.transform = 'translateX(0)';
        } else {
          panel.style.opacity = '0';
          panel.style.transform = 'translateX(0)';
        }
      }

      nextPanel.style.opacity = '1';
      nextPanel.style.transform =
        slideIndex > currentActiveIndex ? 'translateX(100%)' : 'translateX(-100%)';
      nextPanel.style.zIndex = '2';
      currentPanel.style.zIndex = '1';

      // Force reflow so the pre-animation transform is applied before transitioning.
      void nextPanel.offsetWidth;

      requestAnimationFrame(() => {
        if (token !== this.#transitionToken) return;

        nextPanel.style.transition = `transform ${transitionDuration}ms ease-in-out`;
        currentPanel.style.transition = `transform ${transitionDuration}ms ease-in-out`;
        nextPanel.style.transform = 'translateX(0)';
        currentPanel.style.transform =
          slideIndex > currentActiveIndex ? 'translateX(-100%)' : 'translateX(100%)';
      });

      this.#transitionTimer = setTimeout(() => {
        if (token !== this.#transitionToken) return;

        for (const [index, panel] of panels.entries()) {
          if (!(panel instanceof HTMLElement)) continue;
          panel.style.transition = '';
          panel.style.zIndex = '';
          if (index === slideIndex) {
            panel.style.opacity = '1';
            panel.style.transform = 'translateX(0)';
          } else {
            panel.style.opacity = '0';
            panel.style.transform = 'translateX(0)';
          }
        }

        this.#transitionTimer = null;
      }, transitionDuration);
    }

    /**
     * @param {NodeListOf<Element>} controls
     * @param {number} slideIndex
     */
    #setActiveControls(controls, slideIndex) {
      for (const [index, control] of controls.entries()) {
        if (!(control instanceof HTMLElement)) continue;
        const isActive = index === slideIndex;
        control.classList.toggle('is-active', isActive);
        control.setAttribute('aria-selected', isActive ? 'true' : 'false');
        control.setAttribute('tabindex', isActive ? '0' : '-1');
      }
    }

    /**
     * @param {HTMLElement} carousel
     * @returns {number}
     */
    #getCarouselGap(carousel) {
      const track = carousel.querySelector('.feature-slides__carousel-track');
      if (!(track instanceof HTMLElement)) return 16;

      const gap = Number.parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap);
      return Number.isFinite(gap) ? gap : 16;
    }

    /**
     * @param {AbortSignal} signal
     */
    #setupMobileCarousel(signal) {
      const carousel = this.querySelector('.feature-slides__carousel');
      if (!(carousel instanceof HTMLElement)) return;

      carousel.addEventListener(
        'scroll',
        () => {
          const card = carousel.querySelector('.feature-slides__mobile-card');
          if (!(card instanceof HTMLElement)) return;

          const cardWidth = card.offsetWidth;
          const gap = this.#getCarouselGap(carousel);
          const newActiveIndex = Math.round(carousel.scrollLeft / (cardWidth + gap));
          const cards = carousel.querySelectorAll('.feature-slides__mobile-card');

          if (newActiveIndex >= 0 && newActiveIndex < cards.length) {
            this.#switchSlide(newActiveIndex);
          }
        },
        { signal }
      );

      carousel.addEventListener(
        'mousedown',
        (event) => {
          this.#isDown = true;
          carousel.classList.add('is-dragging');
          this.#startX = event.pageX - carousel.offsetLeft;
          this.#scrollLeft = carousel.scrollLeft;
        },
        { signal }
      );

      carousel.addEventListener(
        'mouseleave',
        () => {
          this.#isDown = false;
          carousel.classList.remove('is-dragging');
        },
        { signal }
      );

      carousel.addEventListener(
        'mouseup',
        () => {
          this.#isDown = false;
          carousel.classList.remove('is-dragging');
        },
        { signal }
      );

      carousel.addEventListener(
        'mousemove',
        (event) => {
          if (!this.#isDown) return;
          event.preventDefault();
          const x = event.pageX - carousel.offsetLeft;
          const walk = (x - this.#startX) * 2;
          carousel.scrollLeft = this.#scrollLeft - walk;
        },
        { signal }
      );
    }
  }

  if (!customElements.get('feature-slides')) {
    customElements.define('feature-slides', FeatureSlides);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["split-image-accordion"] && !Shopify.designMode) return;
  try {
    
  class SplitImageAccordion extends HTMLElement {
    /** @type {AbortController | null} */
    #abortController = null;

    /** @type {ReturnType<typeof setInterval> | null} */
    #autoplayInterval = null;

    /** @type {boolean} */
    #autoplayPaused = false;

    /** @type {HTMLButtonElement[]} */
    #triggers = [];

    /** @type {HTMLElement[]} */
    #items = [];

    /** @type {HTMLElement[]} */
    #images = [];

    connectedCallback() {
      this.#abortController = new AbortController();
      const { signal } = this.#abortController;

      this.#cacheElements();
      this.addEventListener('click', this.#onClick, { signal });

      if (this.#shouldAutoplay()) {
        this.#startAutoplay();
        this.addEventListener('pointerenter', this.#pauseAutoplay, { signal });
        this.addEventListener('pointerleave', this.#resumeAutoplay, { signal });
        this.addEventListener('focusin', this.#pauseAutoplay, { signal });
        this.addEventListener('focusout', this.#onFocusOut, { signal });
        document.addEventListener('visibilitychange', this.#onVisibilityChange, { signal });
      }
    }

    disconnectedCallback() {
      this.#stopAutoplay();
      this.#abortController?.abort();
      this.#abortController = null;
      this.#triggers = [];
      this.#items = [];
      this.#images = [];
    }

    #cacheElements() {
      this.#triggers = Array.from(this.querySelectorAll('[data-accordion-trigger]')).filter(
        (el) => el instanceof HTMLButtonElement
      );
      this.#items = Array.from(this.querySelectorAll('.split-image-accordion__item')).filter(
        (el) => el instanceof HTMLElement
      );
      this.#images = Array.from(this.querySelectorAll('.split-image-accordion__image')).filter(
        (el) => el instanceof HTMLElement
      );
    }

    #shouldAutoplay() {
      if (this.dataset.autoplay !== 'true') return false;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;

      return this.#triggers.length > 1;
    }

    /**
     * @param {Event} event
     */
    #onClick = (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const trigger = target.closest('[data-accordion-trigger]');
      if (!(trigger instanceof HTMLButtonElement) || !this.contains(trigger)) return;

      if (trigger.getAttribute('aria-expanded') === 'true') return;

      this.#openItem(trigger);

      if (this.#shouldAutoplay()) {
        this.#restartAutoplay();
      }
    };

    /**
     * @param {HTMLButtonElement} trigger
     */
    #openItem(trigger) {
      const item = trigger.closest('.split-image-accordion__item');
      if (!(item instanceof HTMLElement)) return;

      const itemId = item.dataset.itemId;
      if (!itemId) return;

      for (const otherItem of this.#items) {
        const otherTrigger = otherItem.querySelector('[data-accordion-trigger]');
        const otherBody = otherItem.querySelector('.split-image-accordion__body');
        const isTarget = otherItem === item;

        otherItem.classList.toggle('is-open', isTarget);

        if (otherTrigger instanceof HTMLButtonElement) {
          otherTrigger.setAttribute('aria-expanded', isTarget ? 'true' : 'false');
        }

        if (otherBody instanceof HTMLElement) {
          otherBody.toggleAttribute('inert', !isTarget);
        }
      }

      for (const image of this.#images) {
        image.classList.toggle('is-active', image.dataset.imageId === itemId);
      }
    }

    #getAutoplayDelay() {
      const delaySeconds = Number(this.dataset.autoplayDelay);
      if (Number.isFinite(delaySeconds) && delaySeconds > 0) {
        return delaySeconds * 1000;
      }

      return 5000;
    }

    #startAutoplay() {
      this.#stopAutoplay();
      if (!this.#shouldAutoplay() || this.#autoplayPaused || document.hidden) return;

      this.#autoplayInterval = setInterval(() => {
        this.#advanceAutoplay();
      }, this.#getAutoplayDelay());
    }

    #stopAutoplay() {
      if (this.#autoplayInterval !== null) {
        clearInterval(this.#autoplayInterval);
        this.#autoplayInterval = null;
      }
    }

    #restartAutoplay() {
      this.#stopAutoplay();
      if (this.#autoplayPaused) return;
      this.#startAutoplay();
    }

    #pauseAutoplay = () => {
      this.#autoplayPaused = true;
      this.#stopAutoplay();
    };

    #resumeAutoplay = () => {
      if (this.matches(':hover, :focus-within')) {
        this.#autoplayPaused = true;
        this.#stopAutoplay();
        return;
      }

      this.#autoplayPaused = false;
      this.#startAutoplay();
    };

    /**
     * @param {FocusEvent} event
     */
    #onFocusOut = (event) => {
      const nextTarget = event.relatedTarget;
      if (nextTarget instanceof Node && this.contains(nextTarget)) return;
      this.#resumeAutoplay();
    };

    #onVisibilityChange = () => {
      if (document.hidden) {
        this.#stopAutoplay();
        return;
      }

      this.#resumeAutoplay();
    };

    #advanceAutoplay() {
      if (this.#triggers.length < 2) return;

      const current = this.querySelector('.split-image-accordion__item.is-open [data-accordion-trigger]');
      let nextIndex = 0;

      if (current instanceof HTMLButtonElement) {
        const currentIndex = this.#triggers.indexOf(current);
        if (currentIndex >= 0) {
          nextIndex = (currentIndex + 1) % this.#triggers.length;
        }
      }

      const nextTrigger = this.#triggers[nextIndex];
      if (nextTrigger) {
        this.#openItem(nextTrigger);
      }
    }
  }

  if (!customElements.get('split-image-accordion')) {
    customElements.define('split-image-accordion', SplitImageAccordion);
  }

  } catch(e) { console.error(e); }
})();
})();
